"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCaretPathInfo = void 0;
const slate_1 = require("slate");
const embed_1 = require("./embed");
const math_1 = require("./math");
const link_1 = require("./link");
const CARET_MARK_ORDER = [
    ['bold', 'bold'],
    ['italic', 'italic'],
    ['underline', 'underline'],
    ['code', 'code'],
];
/** Get text of an inline mark inside which `Path` is located. */
const getMarkText = (editor, path, type) => {
    const node = slate_1.Node.get(editor, path);
    if (!slate_1.Text.isText(node) || node[type] !== true)
        return '';
    const [parentElement, parentPath] = slate_1.Editor.parent(editor, path);
    if (!parentElement)
        return '';
    const textIndex = path[path.length - 1];
    const children = parentElement.children;
    let left = textIndex;
    let right = textIndex;
    while (left > 0) {
        const leftNode = children[left - 1];
        if (!slate_1.Text.isText(leftNode) || leftNode[type] !== true)
            break;
        left--;
    }
    while (right < children.length - 1) {
        const rightNode = children[right + 1];
        if (!slate_1.Text.isText(rightNode) || rightNode[type] !== true)
            break;
        right++;
    }
    const startPath = [...parentPath, left];
    const endPath = [...parentPath, right];
    const range = {
        anchor: slate_1.Editor.start(editor, startPath),
        focus: slate_1.Editor.end(editor, endPath),
    };
    return slate_1.Editor.string(editor, range);
};
const getCaretPathInfo = (editor) => {
    const { selection } = editor;
    if (!selection)
        return { path: [] };
    const activeEmbed = (0, embed_1.getActiveEmbed)(editor);
    if (activeEmbed) {
        return {
            path: ['embed'],
            embedUrl: activeEmbed.url,
        };
    }
    const activeMathBlock = (0, math_1.getActiveMathBlockEntry)(editor);
    if (activeMathBlock) {
        return {
            path: ['math'],
            mathThingId: activeMathBlock[0]['@thing'],
        };
    }
    const activeMathInline = (0, math_1.getActiveMathInlineEntry)(editor);
    if (activeMathInline) {
        return {
            path: ['math-inline'],
            mathThingId: activeMathInline[0]['@thing'],
        };
    }
    const point = selection.focus;
    const segments = [];
    const [blockMatch] = slate_1.Editor.nodes(editor, {
        at: point,
        match: (node) => slate_1.Element.isElement(node) && slate_1.Editor.isBlock(editor, node),
    });
    if (blockMatch) {
        const [element] = blockMatch;
        segments.push(element.type);
    }
    let textNode = null;
    try {
        const node = slate_1.Node.get(editor, point.path);
        if (slate_1.Text.isText(node))
            textNode = node;
    }
    catch { }
    const marks = (slate_1.Editor.marks(editor) ?? {});
    const markState = { ...(textNode ?? { text: '' }), ...marks };
    const codeText = markState.code && textNode ? getMarkText(editor, point.path, 'code') : '';
    for (const [key, label] of CARET_MARK_ORDER) {
        if (markState[key])
            segments.push(label);
    }
    const link = (0, link_1.getLinkAttributes)(markState);
    if (link)
        segments.push('link');
    return {
        path: segments,
        ...(link ? { linkHref: link.href } : {}),
        ...(codeText ? { codeText } : {}),
    };
};
exports.getCaretPathInfo = getCaretPathInfo;
